const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const CodeValidationBox = require("./CodeValidationBox");
const styles = require("./styles/PageRedeemSubscription.css");
const OpsUser = require("../../core/vault/OpsUser");
const CopyTable = require("../data/CopyTable");
const redeemCodeCopy = CopyTable.getRedeemCodeStepCopy();
// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "RedeemSubscriptionCode",

		propTypes: {
			cart: PT.object.isRequired,
			user: PT.object.isRequired,
			onContinue: PT.func.isRequired,
			dispatch: PT.func.isRequired, // Injected by HOCs
		},

		getInitialState: function() {
			return {
				code: "",
				checkCodesStatus: "",
			};
		},

		handleValidationStatusChange: function(status, code) {
			this.setState({checkCodesStatus: status, code: code});
		},

		// Saves subscription data in the vault
		saveSubscriptionData: function() {
			this.props.dispatch({
				type: AT.UPDATE_REDEEM_CODES_STUDENT_DATA,
				code: this.state.code,
			});
		},

		handleKeyDown: function(e) {
			if (e.key === "Enter" && this.state.checkCodesStatus === "complete") {
				e.preventDefault();
				this.saveSubscriptionData();
				this.props.onContinue();
			}
		},

		render: function() {
			const isParent = OpsUser.hasParentRole(this.props.user);
			if (isParent) {
				this.props.onContinue();
				return null;
			}

			return (
				<div
					className={styles.sectionWrapper}
					onKeyDown={this.handleKeyDown}
					tabIndex="0"
				>
					<h2 className={styles.title}>{redeemCodeCopy.title}</h2>
					<div className={styles.bodyText}>{redeemCodeCopy.description}</div>
					<CodeValidationBox
						cart={this.props.cart}
						checkCodesStatus={this.state.checkCodesStatus}
						onValidationStatusChange={this.handleValidationStatusChange}
					/>
					<button
						className={styles.primaryButton}
						type="submit"
						disabled={this.state.checkCodesStatus !== "complete"}
						onClick={() => {
							this.saveSubscriptionData();
							this.props.onContinue();
						}}
					>
						Continue
					</button>
				</div>
			);
		},
	})
);
